import { render, staticRenderFns } from "./NewsBanner.vue?vue&type=template&id=4fd72f09&scoped=true&"
import script from "./NewsBanner.vue?vue&type=script&lang=js&"
export * from "./NewsBanner.vue?vue&type=script&lang=js&"
import style0 from "./NewsBanner.vue?vue&type=style&index=0&id=4fd72f09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd72f09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fd72f09')) {
      api.createRecord('4fd72f09', component.options)
    } else {
      api.reload('4fd72f09', component.options)
    }
    module.hot.accept("./NewsBanner.vue?vue&type=template&id=4fd72f09&scoped=true&", function () {
      api.rerender('4fd72f09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/banners/NewsBanner.vue"
export default component.exports